// The whole role in a modal over the page: the same read-only job view the Jobs page shows, with a back link
// that closes it. Shared by Find Candidates (search setup) and Outreach (a project's overview).
import { useEffect } from "react";
import styled, { keyframes } from "styled-components";
import JobDetailView, { JobsVarsScope } from "./JobDetailView";
import { PageScrollLock } from "../utils/useLockPageScroll";

const overlayIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;
const cardIn = keyframes`
  from { opacity: 0; transform: translateY(10px) scale(0.985); }
  to { opacity: 1; transform: none; }
`;
const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
  background: var(--scrim);
  backdrop-filter: blur(3px);
  -webkit-backdrop-filter: blur(3px);
  animation: ${overlayIn} 0.18s ease both;
  @media (max-width: 768px) {
    padding: 16px;
  }
  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;
const Card = styled(JobsVarsScope)`
  width: min(1100px, 100%);
  max-height: calc(100vh - 64px);
  max-height: calc(100dvh - 64px);
  overflow-y: auto;
  border-radius: 16px;
  border: 1px solid var(--line);
  background: var(--bg);
  box-shadow: var(--shadow-lg);
  animation: ${cardIn} 0.22s ease both;
  @media (max-width: 768px) {
    max-height: calc(100dvh - 32px);
  }
  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

export default function JobPreviewModal({ job, onClose, backLabel = "page" }) {
  // Escape closes, like every other modal here.
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);
  if (!job) return null;
  return (
    <Overlay role="dialog" aria-modal="true" aria-label={job.title || "Role"} onMouseDown={(e) => e.target === e.currentTarget && onClose?.()}>
      <PageScrollLock />
      <Card>
        <JobDetailView job={job} onBack={onClose} backLabel={backLabel} descriptionOnly />
      </Card>
    </Overlay>
  );
}
